import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { JETSTREAM_SERVER_US } from '~/app/models/constans';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	JetStreamServerUrl: JETSTREAM_SERVER_US,
	showCaESummaryText: true,
	engineCardKeyfacts: ['maxPowerHp', 'chargingTime'],
	financingDisclaimer: ['globalDisclaimer'],
	financeDomain: 'AUDI.JP',
	hideConsumptionEmissionEngineName: true,
	enableFinancingServices: true,
	useStaticPriceDateRemark: true,
	enablePriceDisclaimer: true,
};
